<template>
  <div class="layout--main">
    <the-steps-navbar class="mobile-hidden" :navbarColor="navbarColor" />

    <MobileNavbar class="sm:hidden" />

    <div class="w-full flex flex-row items-start">
      <cs-sidebar-steps class="hidden sm:flex w-11/12 mobile-hidden" />
      <div class="w-full flex p-0 m-0 content-area">
        <div class="content-wrapper">
          <div class="router-view">
            <div class="router-content mt-0">
              <transition :name="routerTransition" mode="out-in">
                <router-view></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import themeConfig from "@/../themeConfig.js";
import TheStepsNavbar from "../components/TheStepsNavbar.vue";
import CsSidebarSteps from "../components/cs-sidebar-steps/CsSidebarSteps.vue";
import MobileNavbar from "../components/mobile-navbar/MobileNavbar";

export default {
  components: {
    TheStepsNavbar,
    CsSidebarSteps,
    MobileNavbar
  },
  data: () => ({
    navbarColor: themeConfig.navbarColor || "#fff",
    routerTransition: themeConfig.routerTransition || "none"
  }),
  computed: {
    ...mapState("company", ["company"])
  },
  methods: {
    updatePrimaryColor() {
      if (
        this.company &&
        this.company.hasOwnProperty("base_hexcolor") &&
        this.company.base_hexcolor !== ""
      )
        this.$vs.theme({ primary: this.company.base_hexcolor });
    }
  },
  created() {
    this.updatePrimaryColor();
  }
};
</script>

<style lang="scss" scoped>
.content-area {
  max-height: calc(100vh - 62.38px);
  width: calc(100vw - 230px);
  margin-left: 230px;

  @media only screen and (max-width: 576px) {
    margin-left: 0;
    width: 100%;
    height: 100vh;
  }

  .content-wrapper {
    width: 100%;
    max-height: calc(100vh - 74px);
    overflow-x: hidden;
    overflow-y: scroll;

    @media only screen and (max-width: 576px) {
      min-height: calc(100vh - 13rem);
      overflow-x: unset;
    }
  }

  .router-view {
    min-height: calc(100vh - 74px);
    padding: 0.55rem;
    padding-top: 0;

    @media only screen and (max-width: 576px) {
      min-height: calc(100vh - 13rem);
      padding: 0.5rem !important;
    }
  }
}

.router-content {
  min-height: calc(100vh - 13rem);
}

.router-content__area {
  width: 100%;
  height: calc(100vh - 79px);

  @media only screen and (max-width: 576px) {
    min-height: calc(100vh - 13rem);
  }
}

.buttons-footer {
  padding: 1rem 2.2rem;
}

.custom-footer {
  display: flex;
  justify-content: center;
}
</style>
